import './css/styles.scss';

function tjanstekortInit(): void {}

tjanstekortInit();
